import React from 'react'
import { links } from 'common/helpers'
import constants from 'common/helpers/constants'

import NewProductsModal from 'components/modals/newProducts/NewProductsModal/NewProductsModal'

import messages from './messages'

// resolve picture x2
import makeupImage from './images/makeup.jpg'


const MakeupModal = () => (
  <NewProductsModal
    name={constants.modals.newProducts.Makeup}
    eventName={constants.analyticsEvents.popupMakeup}
    link={links.makeup}
    buttonMessageTitle={messages.buttonTitle}
    imgSrc={makeupImage}
    textMessage={messages.text}
  />
)


export default MakeupModal
